export default {
  auth: {
    email: "E-mail",
    password: "Password",
    logout: "Disconnetti",
    sign_in: "Accedi",
    sign_in_with_sso: "Accedi con SSO",
    login_screen: "schermata di accesso",
    back_to_sign_in: "Torna al login",
    reset_password: "Reimposta Password",
    reset_password_code: "Codice Reset Password",
    forget_password: "Password Dimenticata",
    new_password: "Nuova Password",
    re_new_password: "Ripeti Nuova Password",
    login_failed: "Identità non trovata",
    change_password: "Cambia Password",
    continue: "Continua",
    showcase: {
      welcome: "Benvenuto^3000",
      cloud: "Piattaforma cloud di nuova generazione per l'identificazione e la gestione^4000",
      identify:
        "Ti permette di identificare, tracciare e gestire la tua forza lavoro^1000 in modo facile e sicuro^4000",
      manage: "Puoi gestire quando e dove vuoi^4000",
      freedom: "Hai la libertà^3000 di vedere tutto il tuo sistema^3000"
    },
    email_not_found: "Questo indirizzo email non è stato trovato",
    invalid_reset_token: "Codice di reset non valido",
    reset_password_expired: "Devi attendere almeno 3 minuti per reimpostare una nuova password",
    reset_code_expired: "Il codice di reset password è scaduto",
    send_sms_password_code: "Il codice di reset password è stato inviato tramite SMS",
    password_change_successfully: "La tua password è stata modificata con successo",
    invalid_email_or_password: "Email o password non valida",
    invalid_password: "Password non valida",
    current_password: "Password Attuale",
    sso_error: "Si è verificato un errore"
  },
  dashboard: {
    access: {
      table: {
        last_event: "Ultimi Eventi",
        personal: "Dipendente",
        terminal_type: "Tipo Terminale",
        general_info: "Informazioni Generali",
        terminal: "Terminale",
        event_type: "Tipo Evento",
        identity_type: "Tipo Identità",
        time: "Ora",
        event: "Evento",
        location: "Posizione",
        place: "Luogo",
        place_beacon: "Beacon Luogo",
        minor: "Minor",
        major: "Major",
        parent: "Genitore",
        duration: "Durata",
        first_seen: "Prima Vista",
        last_seen: "Ultima Vista",
        max_person_count: "Numero Massimo Persone",
        begin_date_time: "Data Inizio",
        end_date_time: "Data Fine",
        employee_dialog_title: "Informazioni Entrata - Uscita Dipendente",
        empty_zone_message: "Zona Vuota",
        loading_message: "Caricamento"
      },
      monthly_dashboard: "Dashboard Mensile",
      monthly_events: "Eventi Mensili",
      monthly_timesheet_report: "Ritardi",
      absence: "Le Mie Assenze",
      incalculable: "I Miei Non Calcolabili",
      lates: "I Miei Ritardi",
      overtime: "I Miei Straordinari",
      early_leaver: "Le Mie Uscite Anticipate",
      missing_time: "Le Mie Ore Mancanti",
      expected: "I Miei Previsti",
      total_tardiness_average: "Media Ritardi",
      total_leaver_average: "Media Uscite Anticipate",
      total_overtime_average: "Media Straordinari",
      tardiness_minute: "Minuti di Ritardo",
      early_minute: "Minuti di Anticipo",
      overtime_minute: "Minuti di Straordinario",
      short_minute: "min",
      today: "Oggi"
    },
    currency: {
      buying: "Acquisto",
      selling: "Vendita",
      currencies: "Valuta"
    },
    about: {
      about: "Chi Siamo",
      mission: "Missione",
      vision: "Visione"
    },
    menu_of_day: "Menu del Giorno",
    messages: {
      no_data_reminders: "Nessun Promemoria",
      no_data_messages: "Nessun Messaggio",
      no_data_leaves: "Nessuna Richiesta di Ferie",
      no_data_overtimes: "Nessuna Richiesta di Straordinario",
      no_data_expenses: "Nessuna Richiesta di Spesa",
      no_data_imprests: "Nessuna Richiesta di Anticipo",
      no_data_incalculables: "Nessun Non Calcolabile",
      no_data_absences: "Nessuna Assenza"
    },
    request_type: {
      leave: "Richieste di Ferie",
      overtime: "Richieste di Straordinario",
      expense: "Richieste di Spesa",
      imprest: "Richieste di Anticipo"
    },
    weather_forecast: "Previsioni Meteo e Tassi Correnti",
    reminder_tab_title: "Promemoria",
    message_tab_title: "Messaggi",
    data_type_enum: {
      LEAVE_REQUEST: "Richieste di Ferie",
      ACTIVITY: "Attività",
      REMINDER: "Promemoria"
    }
  },
  time: {
    crud: {
      create_overtime: "Crea Richiesta Straordinario"
    },
    event: {
      clock_in: "Entrata",
      clock_out: "Uscita",
      duty_in: "Inizio Turno",
      duty_out: "Fine Turno",
      break_in: "Inizio Pausa",
      break_out: "Fine Pausa",
      lunch_in: "Inizio Pranzo",
      lunch_out: "Fine Pranzo"
    },
    menu: {
      shifts: "Turni",
      timesheets: "Fogli Presenza",
      overtime_requests: "Richieste Straordinario",
      overtime_approval: "Approvazione Straordinari",
      employee_calendar: "Calendario Dipendenti"
    },
    shift_types: {
      FIX: "Fisso",
      FLEXIBLE: "Flessibile",
      OFF_DAY: "Giorno Libero",
      OFFDAY: "Giorno Libero",
      HOLIDAY: "Festivo",
      WORKDAY: "Giorno Lavorativo",
      BREAK: "Giorno di Riposo"
    },
    overtime_approval: {
      employee: "Dipendente",
      workplan: "Piano di Lavoro",
      request_status: "Stato Richiesta",
      reason: "Motivo",
      request_time: "Data Richiesta"
    },
    overtime_request: {
      approve_title: "Approvazione Richiesta Straordinario",
      add_overtime: "Aggiungi Richiesta Straordinario",
      date: "Data Turno",
      workplan: "Turno",
      overtime_in_minutes: "Durata Straordinario",
      short_minute: "min",
      request_status: "Stato",
      request_date: "Data Richiesta",
      period: "Periodo",
      periods: {
        CLOCK_IN: "Entrata",
        CLOCK_OUT: "Uscita",
        CLOCK_IN_OUT: "Entrata Uscita"
      },
      message: "{0} Vuoi approvare la richiesta di straordinario di <b>{2} minuti per il turno del {1}</b>",
      selectedShiftForOvertime: "Turno con straordinari"
    },
    timesheet: {
      employee: "Dipendente",
      employees: "Dipendenti",
      date: "Data",
      type: "Tipo",
      work_plan: "Piano di Lavoro",
      shift: "Turno",
      clock_in: "Entrata",
      clock_in_title: "Ora di Entrata",
      late: "Ritardo",
      reason: "Motivo",
      late_title: "Ritardo in Entrata",
      it: "IT",
      it_title: "Tipo Identità",
      terminal: "Terminale",
      clock_out: "Uscita",
      clock_out_title: "Ora di Uscita",
      early: "Anticipo",
      early_title: "Uscita Anticipata",
      ewt: "EWT",
      ewt_title: "Tempo di Lavoro Previsto",
      awt: "AWT",
      twt_title: "Tempo di Lavoro Totale",
      twt: "TÇS",
      awt_title: "Tempo di Lavoro Effettivo",
      ot: "OT",
      ot_title: "Straordinario",
      mt: "MT",
      mt_title: "Tempo Mancante",
      name: "Dipendente",
      time: "Ora",
      identity_type: "Tipo Identità",
      event_type: "Tipo Evento",
      event_time: "Ora Evento",
      all_events: "Tutti gli Eventi",
      status: "Stato",
      shift_name: "Nome Turno",
      branch: "Filiale",
      unit: "Unità",
      team: "Team",
      jobInfo: "Info Lavoro",
      staffNumber: "Numero Personale",
      information: {
        work_day: "Giorno Lavorativo",
        work_day_desc: "Significa che il dipendente verrà al lavoro quel giorno.",
        work_off: "Giorno Libero",
        work_off_desc: "Quel giorno è il weekend per il dipendente.",
        public_holiday: "Festività",
        public_holiday_desc: "È un giorno festivo per il dipendente.",
        did_not_come_to_work: "Non si è presentato al lavoro",
        did_not_come_to_work_desc:
          "Il dipendente non si è presentato al lavoro nonostante avesse un turno quel giorno.",
        on_leave: "In Ferie",
        on_leave_desc: "Il dipendente è in ferie quel giorno.",
        calculated: "Calcolato",
        calculated_desc: "Significa che il calcolo è stato effettuato per le parole colorate in verde.",
        not_calculated: "Non Calcolato",
        not_calculated_desc: "Significa che il calcolo non è stato effettuato per le parole colorate in rosso."
      },
      total: "Totale",
      ot_mt: "Differenza"
    },
    calendar: {
      holiday: "Festivo",
      off_day: "Giorno Libero",
      breakday: "Giorno di Riposo",
      employee_overtime: "Se il dipendente viene al lavoro in questa data, viene calcolato come straordinario",
      employee_off_day: "È il giorno libero settimanale del dipendente",
      employee_break_day: "È il giorno di riposo del dipendente.",
      shift_loading: "Idenfit sta creando i turni",
      create_shift: "Crea Turno",
      shift_detail: "Dettaglio Turno",
      leave_type: "Tipo Ferie",
      begin_time: "Ora Inizio",
      end_time: "Ora Fine",
      break_time: "Tempo Pausa",
      shift_time: "Orario Turno",
      clock_in_max_overtime: "Massimo Straordinario in Entrata",
      clock_out_max_overtime: "Massimo Straordinario in Uscita",
      lately_tolerance: "Tolleranza Ritardo",
      early_tolerance: "Tolleranza Uscita Anticipata",
      overtime: "Straordinario",
      early_clock_out_tolerance: "Tolleranza Ritardo",
      lately_clock_in_tolerance: "Tolleranza Uscita Anticipata",
      max_clock_in_overtime_in_minutes: "Massimo Straordinario in Entrata in Minuti",
      max_clock_out_overtime_in_minutes: "Massimo Straordinario in Uscita in Minuti",
      min_clock_in_overtime_in_minutes: "Minimo Straordinario in Entrata in Minuti",
      min_clock_out_overtime_in_minutes: "Minimo Straordinario in Uscita in Minuti",
      minimum_overtime: "Straordinario minimo",
      maximum_overtime: "Straordinario massimo",
      midnight_tolerance: "Tolleranza Mezzanotte",
      shift_type: "Tipo Turno",
      count_as_overtime: "Conta come straordinario",
      total_work_time: "Tempo Totale di Lavoro",
      selectWeekends: "Giorni Weekend",
      selectBreaks: "Giorni di Pausa",
      overtime_request: {
        approve_title: "Approvazione Straordinario",
        add_overtime: "Richiedi Straordinario",
        detail_overtime: "Dettaglio Straordinario",
        date: "Data Turno",
        workplan: "Turno",
        overtime_in_minutes: "Tempo Turno",
        request_status: "Stato",
        request_date: "Data Richiesta",
        approval_date: "Data Approvazione",
        period: "Periodo",
        history: "Storico Approvazioni",
        periods: {
          CLOCK_IN: "Entrata",
          CLOCK_OUT: "Uscita",
          CLOCK_IN_OUT: "Entrata & Uscita"
        },
        approved: "{0} Vuoi approvare la richiesta di straordinario di <b>{2} minuti per il turno del {1}</b>?",
        rejected: "{0} Vuoi rifiutare la richiesta di straordinario di <b>{2} minuti per il turno del {1}</b>?",
        approval_to_manager: "Invia approvazione al Manager Straordinari",
        not_approval_to_manager: "Non inviare approvazione al Manager Straordinari",
        pending_approval_manager: "Manager in Attesa di Approvazione",
        processes: {
          approved: "Richiesta approvata",
          pending: "In attesa di approvazione",
          stopped: "Processo di approvazione interrotto poiché la richiesta è stata annullata",
          waiting: "In attesa dell'approvazione del manager precedente",
          denied: "Richiesta annullata"
        }
      },
      multiple_shift_deleting: "Eliminazione Multipla Turni",
      cancel_request: "Annulla Richiesta",
      cancel_request_title: "Annulla Richiesta Turno"
    }
  },
  leave: {
    crud: {
      create: "Aggiungi Richiesta Ferie"
    },
    menu: {
      leave_accruals: "Maturazione Ferie",
      leave_requests: "Richieste Ferie",
      leave_approvals: "Approvazioni Ferie in Sospeso",
      leave_balances: "Saldi Ferie"
    },
    hourly: "Orario",
    daily: "Giornaliero",
    type: "Tipo Ferie",
    begin_time: "Ora Inizio",
    end_time: "Ora Fine",
    begin_date: "Data Inizio",
    end_date: "Data Fine",
    approved_time: "Data Approvazione",
    request_time: "Ora Richiesta",
    approve_or_reject: "Approva o Rifiuta",
    status: "Stato",
    no_approver: "Nessun Approvatore",
    manager: "Manager Ferie",
    managers: "Manager Ferie",
    balance: "Saldo",
    not_leave_accruals: "Questo dipendente non ha ancora maturato ferie",
    permission: {
      employee_leave_approver_message: "Questo dipendente può approvare richieste di permesso da altri dipendenti",
      employee_not_leave_approver_message:
        "Questo dipendente non può approvare richieste di permesso da altri dipendenti",
      employee_shift_approver_message: "Questo dipendente può assegnare turni ad altri dipendenti",
      employee_not_shift_approver_message: "Questo dipendente non può assegnare turni ad altri dipendenti",
      employee_overtime_approver_message:
        "Questo dipendente può approvare richieste di straordinario da altri dipendenti",
      employee_not_overtime_approver_message:
        "Questo dipendente non può approvare richieste di straordinario da altri dipendenti"
    },
    notification: {
      employee_receiver_leave_notification_message:
        "Questi dipendenti possono ricevere notifiche di permesso da altri dipendenti",
      employee_not_receiver_leave_notification_message:
        "Questo dipendente non può ricevere notifiche di permesso da altri dipendenti",
      employee_receiver_shift_notification_message:
        "Questi dipendenti possono ricevere notifiche di assegnazione turni da altri dipendenti",
      employee_not_receiver_shift_notification_message:
        "Questo dipendente non può ricevere notifiche di assegnazione turni da altri dipendenti",
      employee_receiver_overtime_notification_message:
        "Questi dipendenti possono ricevere notifiche di richiesta straordinario da altri dipendenti",
      employee_not_receiver_overtime_notification_message:
        "Questo dipendente non può ricevere notifiche di richiesta straordinario da altri dipendenti"
    },
    respect: "I manager delle ferie sopra avranno la priorità",
    order_is_important: "L'ordine dei manager è importante",
    already_selected_manager: "Hai già selezionato questo manager",
    there_is_no_leave_manager: "Nessun manager ferie assegnato",
    add_leave_manager: "Aggiungi Manager Ferie",
    used: "Utilizzate",
    remaining: "Rimanenti",
    on_leave: "In Ferie",
    period: "Periodo",
    duration: "Durata",
    periods: {
      first_half: "1° Metà",
      second_half: "2° Metà",
      first_quarter: "1° Trimestre",
      second_quarter: "2° Trimestre",
      third_quarter: "3° Trimestre",
      fourth_quarter: "4° Trimestre"
    },
    request: {
      this_day_does_not_count_as_leave: "Questo giorno non conta come ferie",
      leave_balance: "Saldo Ferie",
      max_exceed_leave_balance: "Saldo Massimo Ferie Superato",
      leave_request_count: "Numero Richieste Ferie",
      used: "Utilizzate",
      remaining: "Rimanenti",
      approved: "Approva",
      denied: "Rifiuta",
      leave_decreased_count: "Le ferie verranno diminuite"
    },
    accruals: {
      name: "Nome",
      count: "Maturazione Ferie",
      used: "Utilizzate",
      balance: "Saldo Attuale",
      previous_balance: "Saldo Precedente"
    },
    approvals: {
      leave_approval: "Approvazione Ferie",
      message:
        "Il saldo ferie di tipo <b>{1}</b> di <b>{0}</b> è di <b>{2}</b> giorni. Vuoi approvare un totale di <b>{5}</b> richieste di ferie giornaliere effettuate tra <b>{3}</b> - <b>{4}</b>?"
    },
    cancels: {
      leave_cancel: "Revoca Ferie",
      message: "Qual è il motivo della revoca delle ferie?",
      error_message: "Il campo motivo della cancellazione è obbligatorio"
    },
    error_messages: {
      notice_period_error: "Queste ferie devono essere richieste con almeno {0} giorni di anticipo",
      max_consecutive_error: "Puoi richiedere fino a {0} giorni di ferie alla volta",
      min_consecutive_error: "Puoi richiedere un minimo di {0} giorni di ferie alla volta",
      leave_request_exist_error: "Esiste già una richiesta di ferie per queste date",
      total_leave_balance_error1: "Non hai abbastanza saldo per queste ferie",
      total_leave_balance_error2:
        "Per queste ferie, puoi utilizzare un massimo di {0} giorni dal saldo anticipato, non puoi richiedere ferie perché il tuo saldo anticipato è insufficiente.",
      invalid_dates_error: "Date non valide",
      on_birthday_error: "Puoi utilizzare queste ferie solo nel giorno del tuo compleanno",
      birthday_week_error: "Puoi utilizzare queste ferie solo durante la settimana del tuo compleanno",
      birthday_month_error: "Puoi utilizzare queste ferie solo durante il mese del tuo compleanno"
    },
    e_signature: "Firma Digitale",
    e_signature_leave_form: "Modulo Ferie con Firma Digitale",
    leave_form: "Modulo Ferie",
    leave_cancel: "Annulla Ferie",
    signed: "Firmato",
    not_signed: "Non Firmato",
    requests: {
      days_off_automatically: "Giorni aggiunti automaticamente",
      requested_leave_type_documents: "I file devono essere documenti per le ferie"
    },
    today_counts_as_a_day_off: "Oggi è considerato un giorno di ferie",
    required_document_message: " | C'è {count} documento da caricare | Ci sono {count} documenti da caricare",
    isNexyDayMessage: "Le ferie iniziano il giorno successivo"
  },
  leave_request_status: {
    pending: "In Attesa",
    PENDING: "In Attesa",
    approved: "Approvato",
    APPROVED: "Approvato",
    denied: "Rifiutato",
    DENIED: "Rifiutato",
    cancelled: "Annullato",
    CANCELLED: "Annullato",
    need_extra_detail: "Necessita dettagli aggiuntivi",
    NEED_EXTRA_DETAIL: "Necessita dettagli aggiuntivi",
    null: "Sconosciuto",
    NULL: "Sconosciuto",
    undefined: "Sconosciuto",
    UNDEFINED: "Sconosciuto",
    closed: "Chiuso",
    CLOSED: "Chiuso",
    close_pending: "Chiusura in Attesa",
    CLOSE_PENDING: "Chiusura in Attesa",
    NOT_COME: "Non Venuto",
    not_come: "Non Venuto",
    super_admin: "Approvazione Admin",
    SUPER_ADMIN: "Approvazione Admin"
  },
  time_duration: {
    hour: "Ora",
    minute: "Minuto",
    second: "Secondo"
  },
  leave_type: {
    paid: "Retribuito",
    unpaid: "Non Retribuito",
    on_duty: "In Servizio",
    restricted_holiday: "Festività Limitata"
  },
  leave_status: {
    APPROVED: "Approvato",
    PENDING: "In Attesa",
    DENIED: "Rifiutato",
    CANCELLED: "Annullato",
    NEED_EXTRA_DETAIL: "Necessita Dettagli Aggiuntivi",
    not_come: "Non è ancora arrivato il momento",
    NOT_COME: "Non è ancora arrivato il momento"
  },
  leave_duration: {
    FULL_DAY: "Giorno Intero",
    HALF_DAY: "Mezza Giornata",
    QUARTER_DAY: "Quarto di Giornata",
    HOURLY_DAY: "Giornata a Ore",
    HOURLY: "Orario"
  },
  hr: {
    menu: {
      profile: "Profilo",
      performances: "Prestazioni",
      hiring: "Assunzioni",
      trainings: "Formazione",
      expenses: "Spese",
      imprests: "Anticipi",
      papers: "Documenti",
      paper: "Documento",
      documents: "Documenti",
      health: "Salute",
      debit_tickets: "Biglietti Debito",
      payroll: "Buste Paga",
      events: "Eventi",
      approvals: "Richieste di Approvazione",
      expense_approval: "Richieste Spese",
      imprest_approval: "Richieste Anticipi",
      messages: "Messaggi",
      inbox: "Posta in Arrivo",
      outbox: "Posta in Uscita",
      suggestions: "Suggerimenti",
      notes: "Note",
      travels: "Viaggi",
      travel_requests: "Richieste Viaggio",
      vehicles: "Veicoli",
      menus: "Menu Cibo",
      contact: "Contatti",
      expense: "Spesa",
      expense_request_history: "Storico Richieste Spese",
      imprest: "Anticipo",
      imprest_request_history: "Storico Richieste Anticipi",
      travel: "Viaggio",
      travel_request_history: "Storico Richieste Viaggi",
      debit_ticket_transfer_requests: "Richieste Trasferimento Biglietti Debito",
      training: "Formazione",
      training_requests: "Richieste Formazione",
      training_request_history: "Storico Richieste Formazione",
      survey: "Sondaggio",
      pending_surveys: "Sondaggi in Sospeso",
      completed_surveys: "Sondaggi Completati",
      expired_surveys: "Sondaggi Scaduti",
      paper_request_history: "Storico Richieste Documenti",
      paper_requests: "Richieste Documenti",
      tasks: "Attività"
    },
    account: {
      overview: "Panoramica",
      email: "E-mail",
      information: "Informazioni",
      language_role: "Lingua e Ruolo",
      profile: "Profilo",
      contact: "Contatti",
      personal: "Personale",
      family: "Famiglia",
      education: "Istruzione",
      employment: "Impiego",
      financial: "Finanza",
      social_media: "Social Media",
      body_size: "Misure Corporee",
      mobile_device: "Dispositivi Mobili",
      special_fields: "Campi Speciali",
      messages: "Messaggi",
      notes: "Note",
      management: "Gestione"
    },
    employee: {
      overview: {
        staff_number: "Numero Dipendente",
        branch: "Filiale",
        unit: "Unità",
        team: "Team",
        email: "E-mail",
        job_info: "Informazioni Lavoro",
        title: "Titolo",
        leave: {
          manager: "Responsabile Permessi",
          managers: "Responsabili Permessi",
          approver: "Approvatore Permessi"
        },
        hired_date: "Data Assunzione",
        status: "Stato",
        manager: "Responsabile",
        shift_manager: "Responsabile Turni",
        shift_managers: "Responsabili Turni",
        role: "Ruolo"
      },
      information: {
        identity_number: "Numero Identità",
        first_name: "Nome",
        last_name: "Cognome",
        work_email: "Email Lavoro",
        phone: "Telefono",
        email_and_sms_send_question: "Inviare notifiche email e sms a questo dipendente?"
      },
      profile: {
        identity_number: "Numero Identità",
        first_name: "Nome",
        last_name: "Cognome",
        work_email: "Email Lavoro",
        phone: "Telefono",
        email_and_sms_send_question: "Inviare notifiche email e sms a questo dipendente?",
        service_line: "Linea di Servizio"
      },
      language_role: {
        language: "Lingua",
        role: "Ruolo"
      },
      contact: {
        email: "E-mail",
        address: "Indirizzo",
        secondary_phone: "Telefono Secondario",
        fixed_phone: "Telefono Fisso",
        work_phone: "Telefono Lavoro",
        spouse_phone: "Telefono Coniuge",
        extension_number: "Numero Interno",
        emergency_contact_name: "Nome Contatto Emergenza",
        emergency_contact_phone: "Telefono Contatto Emergenza"
      },
      personal: {
        pasaport_number: "Numero Passaporto",
        birth_date: "Data di Nascita",
        place_of_birth: "Luogo di Nascita",
        nationality: "Nazionalità",
        blood_type: "Gruppo Sanguigno",
        gender: "Genere",
        disability_level: "Livello Disabilità",
        ex_convict: "Ex Detenuto",
        driver: "Patente",
        military_service: "Servizio Militare",
        suspended_until: "Sospeso Fino A",
        hes_code: "Codice HES",
        hes_expired_date: "Data Scadenza Codice HES"
      },
      family: {
        marital_status: "Stato Civile",
        spouse_name: "Nome Coniuge",
        child_count: "Numero Figli",
        tenant: "Inquilino",
        martyrs_relatives: "Parenti Caduti",
        disability_child_count: "Numero Figli Disabili",
        date_of_marriage: "Data Matrimonio",
        father_name: "Nome Padre",
        mother_name: "Nome Madre",
        mothers_maiden_name: "Cognome da Nubile Madre",
        sibling_count: "Numero Fratelli",
        child_info: "Info Figli",
        add_child_info: "Aggiungi Info Figlio"
      },
      education: {
        graduation: "Laurea",
        school: "Scuola",
        faculty: "Facoltà",
        department: "Dipartimento",
        graduation_grade: "Voto Laurea",
        academic_title: "Titolo Accademico",
        languages: "Lingue",
        licence_file: "File Licenza"
      },
      employment: {
        staff_number: "Numero Dipendente",
        branch: "Filiale",
        unit: "Unità",
        team: "Team",
        job_info: "Info Lavoro",
        manager: "Responsabile",
        agency: "Agenzia",
        ssn: "Codice Fiscale",
        passive: "Passivo",
        hired_date: "Data Assunzione",
        started_date: "Data Inizio",
        employment_type: "Tipo Impiego",
        collar_type: "Tipo Colletto",
        quite_job: "Dimissioni",
        quit_job_reason: "Motivi Dimissioni",
        quit_job_reason_description: "Descrizione",
        description: "Descrizione",
        quit_job_date: "Data Dimissioni",
        have_an_interview_made: "Colloquio Effettuato",
        have_an_interview_made_not: "Nessun Colloquio Effettuato",
        integration_value: "Numero Integrazione",
        research_and_development_person: "Dipendente R&S",
        social_security_type: "Tipo Previdenza Sociale",
        company: "Azienda",
        allowance_date: "Data Inizio Indennità"
      },
      financial: {
        iban: "IBAN",
        ticket_number: "Numero Ticket",
        bank_account_number: "Numero Conto Bancario",
        bank_branch: "Filiale Banca",
        salary: "Stipendio",
        ticket_price: "Valore Ticket",
        previous_salary: "Stipendio Precedente",
        previous_ticket_price: "Valore Ticket Precedente",
        yearly_premium: "Premio Annuale",
        monthly_stoppage: "Trattenuta Mensile",
        health_insurance_person_count: "Numero Persone Assicurazione Sanitaria",
        agi: "Indennità Minima Vitale",
        gross_salary: "Stipendio Lordo",
        pay_to_net: "Stipendio Netto",
        pay_to_gross: "Stipendio Lordo",
        salary_type: "Tipo Pagamento Stipendio"
      },
      social_media: {
        facebook: "Facebook",
        twitter: "Twitter",
        instagram: "Instagram",
        linkedin: "Linkedin",
        skype: "Skype"
      },
      body_size: {
        weight: "Peso",
        height: "Altezza",
        shirt_size: "Taglia Camicia",
        pants_size: "Taglia Pantaloni",
        shoe_size: "Numero Scarpe",
        waistcoat: "Gilet",
        coat: "Cappotto"
      },
      management: {
        manager: "Responsabile",
        leave_managers: "Responsabili Permessi",
        shift_managers: "Responsabili Turni",
        overtime_managers: "Responsabili Straordinari",
        expense_managers: "Responsabili Spese"
      },
      mobile_device: {
        serial_number: "Numero Seriale",
        multiple_device_allowed: "Dispositivi Multipli Consentiti"
      }
    },
    performance: {
      results: {
        evaluatee: "Valutato",
        published_evaluators: "Valutatori Pubblicati",
        unpublished_evaluators: "Valutatori Non Pubblicati",
        kpi_score: "Punteggio KPI",
        competence_score: "Punteggio Competenze",
        totalCount: "Totale Partecipanti",
        publishedCount: "Partecipanti Attivi",
        evaluation_name: "Nome Valutazione",
        total_score: "Punteggio Totale",
        status: "Stato",
        period: "Periodo",
        scoring: "Punteggio",
        beginDate: "Data Inizio",
        endDate: "Data Fine"
      },
      table: {
        name: "Nome",
        type: "Tipo Performance",
        score_range: "Intervallo Punteggio",
        evaluatee: "Dipendente da Valutare",
        expiration_period: "Periodo Scadenza",
        validation_period: "Periodo Validazione",
        status: "Stato Valutazione",
        categories: "Categorie"
      },
      depths: {
        depth_1: "1° Livello",
        depth_2: "2° Livello",
        depth_3: "3° Livello",
        depth_4: "4° Livello",
        depth_5: "5° Livello"
      },
      add: {
        kpi: "Aggiungi KPI",
        competence: "Aggiungi Competenza",
        pool: "Voglio aggiungere dal pool",
        custom: "Voglio aggiungere nuovo",
        kpi_group: "Aggiungi Gruppo KPI",
        competence_group: "Aggiungi Gruppo Competenze"
      },
      detail: {
        kpi_group: "Dettaglio Gruppo KPI",
        competence_group: "Dettaglio Gruppo Competenze"
      },
      crud: {
        detail: {
          template: "Dettaglio Template",
          evaluation: "Dettaglio Piano Valutazione"
        }
      },
      type: {
        KPI: "KPI",
        COMPETENCE: "Competenza"
      },
      validation: {
        add_item: "Devi aggiungere domande alla categoria {0}",
        template_exist_category: "Categoria {0} è stata aggiunta",
        template_must_a_category: "Deve esserci almeno una categoria nel template di performance",
        question_total_weight_required: "Il peso totale delle domande deve essere {0}%",
        question_total_weight: "Peso totale delle domande {0}%",
        category_not_exist: "Questa categoria non esiste",
        category_total_weight_equals_in_questions:
          "Poiché il peso totale della categoria {0} è {1}%, il peso totale delle domande appartenenti a questa categoria deve essere {1}%.",
        category_in_question_required: "Deve esserci almeno una domanda nella categoria {0}",
        question_weight_required: "Inserisci il peso di {0}"
      },
      information:
        '<p class="body-1 mt-5">' +
        "Puoi creare la tua lista di KPI e competenze selezionando le categorie KPI & COMPETENZE." +
        "</p>" +
        '<p class="body-1">' +
        "Puoi effettuare una valutazione basata sulle domande inserendo il loro peso nelle domande di KPI e competenze definite nella categoria selezionata" +
        "</p>" +
        '<p class="body-1">' +
        "La somma delle domande nella lista che hai aggiunto dovrebbe essere uguale al peso che hai impostato per KPI o COMPETENZE." +
        "</p>",
      total_evaluatees_count: "Totale valutati {0}",
      waiting_evaluates_finish: "Si attende che {0} persone completino la valutazione",
      complete_evaluation: "Questa valutazione è stata completata",
      expiration_date: "Data Scadenza",
      template_name: "Nome Template",
      kpi: "KPI",
      kpi_category: "Categoria KPI",
      kpis: "KPI",
      competence: "Competenza",
      competence_category: "Categoria Competenze",
      competences: "Competenze",
      result_view: "Mostra Risultati",
      waiting: "In Attesa",
      hourly: "Orario",
      weekly: "Settimanale",
      monthly: "Mensile",
      yearly: "Annuale",
      score: "Punteggio",
      star: "Stella",
      weight: "Peso",
      point: "Punto",
      person: "Persona",
      persons: "Persone",
      period_type: "Periodo",
      score_type: "Tipo Punteggio",
      score_min_count: "Punteggio Minimo",
      score_max_count: "Punteggio Massimo",
      evaluation: "Valutazione",
      evaluates: "Valutati",
      evaluators: "Valutatori",
      self: "Auto",
      superior: "Superiore",
      subordinates: "Subordinati",
      same: "Stesso",
      flexible: "Flessibile",
      period: "Periodo",
      expiration_dates: "Data Scadenza",
      expiration_begin_date: "Data Inizio Scadenza",
      expiration_end_date: "Data Fine Scadenza",
      level: "Livello",
      depth: "Profondità",
      validation_date: "Data Validazione",
      validation_begin_date: "Data Inizio Validazione",
      validation_end_date: "Data Fine Validazione",
      published_date_time: "Data Pubblicazione",
      degree_360: "360°",
      m2m: "M2M",
      published: "Avvia Valutazione",
      published_start: "Avvia Valutazione",
      evaluation_done: "Valutazione Completata",
      are_you_sure: "Sei sicuro?",
      are_you_text: "Vuoi avviare questa valutazione?",
      performance_item: {
        title: "Performance"
      },
      my_evaluatees: "I Miei Valutati",
      my_evaluated: "Le Mie Valutazioni",
      info_dialog_title: "Informazione",
      info_dialog_message:
        "La tua valutazione è stata elaborata, quando il processo sarà completato, la tua valutazione sarà riflessa nel sistema."
    },
    training: {
      plan: "Piano Formazione",
      name: "Nome Formazione",
      type: "Tipo Formazione",
      organizer: "Organizzatore",
      lecturer: "Docente",
      terminal: "Terminale",
      sessions: "Sessioni",
      session: "Sessione",
      training_type: {
        ONLINE: "Online",
        CLASSROOM: "In Aula",
        ON_SITE: "Sul Campo"
      },
      training_detail: "Dettaglio Formazione",
      location: "Luogo",
      description: "Descrizione",
      training: "Formazione",
      request_training: "Richiedi Formazione",
      training_requests: "Richieste Formazione",
      request_date: "Data Richiesta",
      abolisher: "Annullatore",
      approval_history: "Storico Approvazioni",
      cancelled_date: "Data Annullamento",
      hr_manager: "Responsabile HR",
      approval_date: "Data Approvazione",
      cancel_request: "Annulla Richiesta",
      cancellation_note: "Nota di annullamento?",
      request_cancellation_process: "Processo Annullamento Richiesta Formazione",
      request_approval_process: "Processo Approvazione Richiesta Formazione",
      denied: "Rifiuta",
      approved: "Approva",
      training_planned: "Formazione Pianificata"
    },
    expense: {
      name: "Nome Spesa",
      type: "Tipo Spesa",
      amount: "Importo",
      date: "Data Richiesta",
      status: "Stato",
      attachment: "Allegato",
      create_expense: "Richiedi Spesa",
      travel: "Viaggio",
      approved_amount: "Importo Approvato",
      expense_type: {
        expense_type: "Tipo Spesa"
      },
      payment_type: {
        CASH: "Contanti",
        CREDIT_CARD: "Carta di Credito",
        PREPAID_CARD: "Carta Aziendale",
        OTHER: "Altro",
        null: "Non Specificato"
      }
    },
    imprest: {
      amount: "Importo",
      period: "Periodo Anticipo",
      reason: "Motivo",
      status: "Stato",
      create_imprest: "Richiedi Anticipo",
      travel: "Viaggio",
      approved_amount: "Importo Approvato",
      date: "Data"
    },
    paper: {
      name: "Nome Documento",
      type: "Tipo Documento",
      issue_date: "Data Emissione",
      expire_date: "Data Scadenza",
      signature_status: "Stato Firma",
      edit_paper: "Modifica Documento",
      paper_include_process: "L'approvazione del documento deve essere inviata al Responsabile Risorse Umane",
      paper_not_include_process: "L'approvazione del documento non deve essere inviata al Responsabile Risorse Umane",
      paper_required_fields_missing: "Tipo documento e stato firma mancanti. Per favore completali.",
      signature_types: {
        NOT_REQUIRED: "Non Richiesta",
        STANDARD_SIGNATURE: "Firma Standard",
        BIOMETRIC_SIGNATURE: "Firma Biometrica",
        SIGNED: "Firmato",
        null: "-",
        E_SIGNATURE: "Firma Digitale"
      },
      add_paper: "Aggiungi Documento",
      papers: {
        issue_date: "Data Emissione",
        expire_date: "Data Scadenza"
      }
    },
    document: {
      name: "Nome Documento",
      type: "Tipo Documento",
      category: "Categoria Documento",
      sender: "Mittente",
      date: "Data",
      add_document: "Aggiungi Documento",
      mobile_accessible_disable: "Accesso mobile disabilitato",
      mobile_accessible_enable: "Accesso mobile abilitato"
    },
    health: {
      name: "Nome",
      category: "Categoria",
      from: "Data Inizio",
      to: "Data Fine",
      disease_detail: "Dettaglio Malattia",
      importance: "Importanza",
      importance_enum: {
        LOW: "Bassa",
        MEDIUM: "Media",
        HIGH: "Alta"
      },
      medicines: "Medicinali",
      attachment: "Allegato",
      description: "Descrizione"
    },
    debit_tickets: {
      asset: "Bene",
      borrow_date: "Data Prestito",
      due_date: "Data Scadenza",
      give_back_date: "Data Restituzione",
      quantity: "Quantità",
      transfer: "Trasferimento",
      transfer_approval: "Approvazione Trasferimento",
      approver: "Dipendente da Trasferire",
      debit_transfer: "Trasferimento Debito",
      download_form: "Scarica Modulo",
      DEBIT_TRANSFER_DUPLICATE_EXCEPTION: "Esiste già una richiesta di trasferimento per questo debito",
      DATA_INTEGRITY_VIOLATION_EXCEPTION: "Questo debito è già registrato a tuo nome"
    },
    payroll: {
      month: "Mese",
      created_date: "Data Creazione",
      file: "File"
    },
    events: {
      name: "Nome",
      type: "Tipo",
      owner: "Proprietario",
      online: "Online",
      begin_date: "Data Inizio",
      end_date: "Data Fine",
      activity: "Attività"
    },
    expense_approval: {
      employee: "Dipendente",
      description: "Descrizione",
      amount: "Importo",
      status: "Stato",
      request_date: "Data Richiesta",
      document: "Documento",
      expense_approval: "Approvazione Spesa",
      message: "{0} ha richiesto una spesa di <b>{3}</b> di tipo <b>{2}</b> il <b>{1}</b>, vuoi approvare?"
    },
    imprest_approval: {
      employee: "Dipendente",
      amount: "Importo",
      status: "Stato",
      request_date: "Data Richiesta",
      imprest_approval: "Approvazione Anticipo",
      message: "{0} ha richiesto un anticipo di <b>{2}</b> il <b>{1}</b>, vuoi approvare?",
      approved_amount: "Importo Approvato",
      requested_amount: "Importo Richiesto"
    },
    hiring: {
      job_posting: "Annuncio di Lavoro",
      applicant: "Candidato",
      applicants: "Candidati",
      interview: "Colloquio",
      assessment_date: "Data Valutazione",
      working_date: "Data di Lavoro",
      last_job: "Ultimo Lavoro",
      last_position_level: "Ultimo Livello di Posizione",
      evaluator: "Valutatore",
      evaluators: "Valutatori",
      weight: "Peso",
      link: "Link",
      skill: "Competenza",
      rate: "Valutazione",
      rating: "Punteggio",
      table: {
        applicant: "Candidato",
        job_posting: "Annuncio di Lavoro",
        last_job: "Ultimo Lavoro",
        assessment: "Valutazione",
        rating: "Punteggio",
        assessment_date: "Data Valutazione",
        status: "Stato",
        evaluators: "Valutatori",
        evaluator: "Valutatore"
      },
      skill_type: {
        soft: "Soft",
        technical: "Tecnico",
        question: "Domanda",
        link: "Link"
      }
    },
    message: {
      message_type: "Tipo Messaggio",
      sender: "Mittente",
      receivers: "Destinatari",
      importance: "Importanza",
      title: "Titolo",
      body: "Contenuto",
      whom: "A chi",
      date: "Data",
      message_type_enum: {
        EMAIL: "E-mail",
        SMS: "Sms",
        IN_APP: "Notifica"
      },
      message_importance_enum: {
        LOW: "Bassa",
        MEDIUM: "Media",
        HIGH: "Alta"
      },
      send_message: "Invia Messaggio",
      success_message: "{1} inviato a {0} persona | {1} inviato a {0} persone"
    },
    suggestion: {
      category: "Categoria Suggerimento",
      title: "Suggerimenti",
      add_suggestion: "Aggiungi Suggerimento",
      body: "Messaggio",
      owner: "Proprietario"
    },
    note: {
      notes: "Note",
      title: "Titolo",
      body: "Contenuto",
      attachment: "Allegato",
      description: "Descrizione",
      add_note: "Aggiungi Nota",
      owner: "Dipendente",
      importance: "Importanza"
    },
    travel: {
      request_travel: "Richiedi un Viaggio",
      leave_request: "Richiesta Permesso",
      travels: "Viaggi",
      travel: "Viaggio",
      travel_detail: "Dettaglio Viaggio",
      start_work_date: "Data Inizio Lavoro",
      is_domestic: "È Nazionale?",
      country: "Paese",
      city: "Città",
      region: "Regione",
      is_rent_car: "Noleggio Auto?",
      is_shuttle: "Navetta?",
      description: "Descrizione",
      reason: "Motivo",
      status: "Stato",
      expense_message: "<strong>{0}</strong> ha richiesto di spendere <strong>{2}</strong> il <strong>{1}</strong>",
      imprest_message: "<strong>{0}</strong> ha richiesto un anticipo di <strong>{2}</strong> il <strong>{1}</strong>",
      subsistence_message:
        "Al dipendente <strong>{0}</strong> è stata data una diaria di <strong>{2}</strong> il <strong>{1}</strong>",
      travel_dates: "Date Viaggio",
      pending_travel_approvals: "Approvazioni Viaggio in Sospeso",
      travel_process: "Processo Viaggio",
      travel_details: "Dettagli Viaggio",
      no_detail_item: "Nessun dettaglio",
      add_new_detail: "Aggiungi Nuovo Dettaglio",
      detail_type: "Tipo Dettaglio",
      detail_subtype: "Sottotipo Dettaglio",
      travel_detail_type_enum: {
        TRANSFER: "Trasferimento",
        LAYOVER: "Scalo",
        BUSINESS: "Business",
        TRAVEL_INSURANCE: "Assicurazione Viaggio"
      },
      travel_detail_subtype_enum: {
        BUS: "Autobus",
        PLANE: "Aereo",
        TRAIN: "Treno",
        SHIP: "Nave",
        CAR: "Auto",
        HOTEL: "Hotel",
        HOSTEL: "Ostello",
        VILLA: "Villa",
        FACTORY: "Fabbrica",
        OFFICE: "Ufficio",
        TRAVEL_HEALTH_POLICY: "Polizza Sanitaria Viaggio"
      },
      begin_date: "Data Inizio",
      end_date: "Data Fine",
      expenses: "Spese",
      imprests: "Anticipi",
      debits: "Debiti",
      borrow_date: "Data Prestito",
      due_date: "Data Scadenza",
      give_back_date: "Data Restituzione",
      quantity: "Quantità",
      name: "Nome",
      category: "Categoria",
      model: "Modello",
      subsistences: "Diarie",
      project: "Progetto",
      attrition: "Tasso di Logoramento",
      new_leave_request: "Richiedi Permesso",
      adding_expense: "Aggiunta Spesa",
      adding_imprest: "Aggiunta Anticipo",
      adding_subsistence: "Aggiunta Diaria",
      adding_debit: "Aggiunta Debito",
      assignment_form: "Modulo di Assegnazione"
    },
    travel_request: {
      employee: "Dipendente",
      begin_date: "Data Inizio",
      end_date: "Data Fine",
      start_work_date: "Data Inizio Lavoro",
      status: "Stato",
      request_date: "Data Richiesta",
      travel_approval: "Approvazione Viaggio",
      message: "<b>{0}</b> ha richiesto un viaggio tra <b>{1}</b> - <b>{2}</b>, vuoi approvare?"
    },
    vehicle: {
      plate_number: "Numero Targa",
      brand: "Marca",
      model: "Modello",
      year: "Anno",
      branch: "Filiale",
      employee: "Dipendente"
    },
    contact: {
      employee: "Dipendente",
      email: "E-mail",
      phone: "Numero Telefono"
    },
    projects: {
      project: "Progetto",
      employee_count_message: "Nessun dipendente | 1 dipendente | {count} dipendenti"
    },
    debit_ticket_transfer_request: {
      requester: "Richiedente",
      asset: "Bene",
      approval_message:
        "<strong>{0}</strong> ha richiesto di trasferire il bene con le seguenti informazioni al tuo peculato, vuoi confermare?"
    },
    survey: {
      name: "Nome Sondaggio",
      published_date: "Data Pubblicazione",
      end_date: "Data Fine",
      start_survey: "Inizia Sondaggio",
      survey_privacy: "Privacy Sondaggio",
      status: "Stato",
      pending_title: "Sondaggi da Completare",
      completed_title: "Sondaggi a cui ho Partecipato",
      expired_title: "Sondaggi Scaduti",
      complete_survey: "Completa Sondaggio",
      survey_information: "Informazioni Sondaggio",
      exit: "Esci",
      save_and_finish: "Salva e Termina",
      status_enum: {
        completed: "Completato",
        continuous: "In Corso",
        expired: "Scaduto"
      },
      section_count: "Numero Sezioni",
      question_count: "Numero Domande",
      estimated_duration: "Durata Stimata",
      description: "Descrizione",
      anonymous_on: "Votazione Chiusa",
      anonymous_off: "Votazione Aperta",
      enter_answer: "Puoi inserire una risposta",
      your_answer: "La tua risposta",
      please_select: "seleziona"
    },
    employee_requesting: "Richiedente",
    employee_creating: "Segnalante"
  },
  message: {
    saved_successfully: "Salvato con Successo",
    registration_failed: "Salvataggio Fallito",
    updated_successfully: "Aggiornato con Successo",
    deleted_successfully: "Eliminato con Successo",
    download_email_report: "Clicca il pulsante per scaricare il file",
    clock_ip_error: "L'indirizzo IP non è tra gli indirizzi IP consentiti",
    evaluation_date_range_error_message: "Non sei nel periodo di valutazione attivo",
    leave_calculate_error: "Errore di calcolo",
    required_document_message: "C'è un documento che devi caricare",
    notice_period_error: "Questa assenza deve essere richiesta con almeno {0} giorni di anticipo",
    max_consecutive_error: "Puoi richiedere fino a {0} giorni di assenza alla volta",
    min_consecutive_error: "Puoi richiedere un minimo di {0} giorni di assenza alla volta",
    leave_request_exist_error: "Esiste già una richiesta di assenza per queste date",
    total_leave_balance_error1: "Non hai abbastanza saldo per questa assenza",
    total_leave_balance_error2:
      "Per questa assenza, puoi utilizzare un massimo di {0} giorni dal saldo anticipato, non puoi richiedere l'assenza perché il tuo saldo anticipato è insufficiente.",
    network_error: "Errore di Rete",
    no_record_found: "Nessun Record Trovato",
    max_range_error: "Puoi scegliere al massimo {0} giorni!",
    something_went_wrong: "Spiacenti, qualcosa è andato storto",
    less_than_x_mb_error: "La dimensione massima del file deve essere {0} MB",
    delete_warning_message: "Questo record verrà eliminato, sei sicuro?",
    delete_operation: "Operazione di Eliminazione"
  },
  global: {
    comment: "Commento",
    description: "Descrizione",
    day: "Giorno",
    note: "Nota",
    employee: "Dipendente",
    address: "Indirizzo",
    explanation: "Spiegazione",
    hour: "Ora",
    month: "Mese",
    phone: "Telefono",
    status: "Stato",
    file: "File",
    greeting: "Ciao, {0}",
    search_for_employee: "Cerca dipendente...",
    others: "Altri",
    importance_enum: {
      LOW: "Bassa",
      MEDIUM: "Media",
      HIGH: "Alta"
    },
    importance: "Importanza",
    date: "Data",
    loading_message: "Caricamento...",
    birth_date: "Data di Nascita",
    min_character_message: "Devi inserire almeno {0} caratteri",
    no_employee_message: "Nessun dipendente trovato con i criteri di ricerca specificati.",
    employees: "Dipendenti",
    beginDate: "Data Inizio",
    endDate: "Data Fine",
    beginTime: "Ora Inizio",
    endTime: "Ora Fine",
    year: "Anno",
    message: "Messaggio",
    detail: "Dettaglio",
    country: "Paese",
    active_employees: "Dipendenti Attivi",
    passive_employees: "Dipendenti Passivi",
    maxEmployeeCount: "Numero Massimo Dipendenti",
    years_old: "anni",
    print: "Stampa",
    expense_management: "Gestione Spese",
    paymentType: "Tipo Pagamento",
    employee_selected: "Seleziona dipendente...|1 dipendente selezionato|{count} dipendenti selezionati",
    shift_selected: "Seleziona turno...|1 turno selezionato|{count} turni selezionati",
    shifts_type: "Turni {0}",
    total_hours: "Ore Totali",
    name: "Nome",
    reason: "Motivo",
    organization: "organizzazione",
    minute: "Minuto",
    from: "Da",
    to: "A",
    shift: "Turno",
    uploaded_files: "File Caricati",
    manager: "Responsabile",
    selected: "{0} selezionato",
    search: "Cerca",
    file_preview: "Anteprima File",
    filename: "Nome File",
    error: "Errore",
    completed: "Completato",
    drop_files: "Trascina qui i file o clicca per selezionarli",
    loading: "Caricamento..."
  },
  assessment: {
    very_poor: "Molto Scarso",
    poor: "Scarso",
    normal: "Normale",
    good: "Buono",
    very_good: "Molto Buono",
    na: "Non Valutato"
  },
  buttons: {
    home: "Dashboard",
    ok: "Ok",
    delete: "Elimina",
    back: "Indietro",
    save: "Salva",
    update: "Aggiorna",
    edit: "Modifica",
    cancel: "Annulla",
    close: "Chiudi",
    dont_save: "Esci senza salvare",
    dont_save_continue: "Continua senza salvare",
    save_changes: "Salva Modifiche",
    evaluation_finish: "Termina Valutazione",
    assign: "Assegna",
    add: "Aggiungi {0}",
    add_and_new: "Aggiungi e Nuovo",
    refresh: "Aggiorna",
    filter: "Filtra",
    export: "Esporta",
    create: "Crea {0}",
    create_and_new: "Crea e Nuovo",
    download: "Scarica",
    yes: "Sì",
    no: "No",
    clear: "Pulisci",
    filter_results: "Filtra Risultati",
    delete_document: "Elimina Documento",
    scan: "Scansiona",
    send_message: "Invia Messaggio",
    send: "Invia",
    apply: "Applica",
    info: "Informazioni",
    prev: "Precedente {0}",
    next: "Successivo {0}",
    list_table: "Modalità Tabella",
    list_card: "Modalità Scheda",
    continue: "Continua",
    show_all: "Mostra Tutto",
    cancel_leave: "Annulla Assenza",
    select_all: "Seleziona Tutto",
    upload: "Carica",
    file_upload: "Carica File",
    file_download: "Operazioni File",
    import: "Importa",
    upload_template: "Carica Template",
    download_template: "Scarica Template",
    trigger: "Attiva",
    action: "Azione",
    send_registration_credentials: "Invia Credenziali di Registrazione",
    on: "Acceso",
    off: "Spento",
    uploads: {
      employee: "Importa Dipendenti",
      leave: "Importa Assenze"
    },
    multiple_delete_shift: "Eliminazione Turni Multipla",
    multiple_upload_shift: "Caricamento Turni Multiplo",
    multiple_actions: "Azioni Multiple",
    send_email_and_sms_notification: "Invia Notifica E-mail & SMS",
    add_expense: "Aggiungi Spesa",
    add_imprest: "Richiedi Anticipo",
    add_overtime: "Richiedi Straordinario",
    add_leave_request: "Aggiungi Richiesta Assenza",
    evaluatee: "Valutato",
    add_skill: "Aggiungi Competenza",
    sign: "Firma",
    skip: "Salta",
    back_to_home: "Torna alla Home",
    please_select: "Seleziona...",
    preview: "Anteprima"
  },
  response: {
    success: {
      ok: "Operazione completata con successo",
      update: "Aggiornato con Successo",
      delete: "Eliminato con Successo",
      send_sms_password_code: "Il codice di reset password è stato inviato via SMS"
    },
    error: {
      user_not_found: "Nome utente o password non validi",
      network_error: "Errore di Rete"
    }
  },
  request_status: {
    PENDING: "In Attesa di Approvazione",
    pending: "In Attesa di Approvazione",
    approved: "Approvato",
    APPROVED: "Approvato",
    denied: "Rifiutato",
    DENIED: "Rifiutato",
    cancelled: "Annullato",
    CANCELLED: "Annullato",
    NEED_EXTRA_DETAIL: "Richiesti Dettagli Aggiuntivi",
    need_extra_detail: "Richiesti Dettagli Aggiuntivi",
    undefined: "Non Definito"
  },
  shift_types: {
    FIX: "Fisso",
    FLEXIBLE: "Flessibile",
    OFF_DAY: "Giorno Libero",
    OFFDAY: "Giorno Libero",
    HOLIDAY: "Festivo",
    WORKDAY: "Giorno Lavorativo",
    BREAK: "Pausa",
    OVERTIME: "Straordinario",
    OVERTIME_SHIFT: "Straordinario",
    ON_LEAVE: "In Assenza"
  },
  shift: {
    overtime: "Straordinario",
    missing_time: "Tempo Mancante",
    shift_parameters: "Parametri Turno",
    break: "Pausa",
    sub_events: "Eventi Secondari",
    included_calculation: "Incluso nel calcolo",
    not_included_calculation: "Non incluso nel calcolo",
    included_overtime_calculation: "Straordinario non incluso nel calcolo",
    not_included_overtime_calculation: "Straordinario incluso nel calcolo",
    not_included_missing_time_calculation: "Tempo mancante non incluso nel calcolo",
    included_missing_time_calculation: "Tempo mancante incluso nel calcolo",
    work_day: "Giorno Lavorativo",
    overtime_day: "Giorno di Straordinario",
    full_time: "Tempo Pieno",
    absent: "Assente",
    unpaid_leave: "Assenza non Retribuita",
    paid_leave: "Assenza Retribuita",
    public_holiday: "Festività",
    on_leave: "In Assenza",
    off_day: "Giorno Libero",
    break_day: "Giorno di Pausa",
    incalculable: "Turno non Calcolabile"
  },
  sensors: {
    NFC: "Nfc",
    FACE: "Volto",
    RFID: "Rfid",
    FINGER: "Impronta Digitale",
    BLUETOOTH: "Bluetooth",
    GATEWARE: "Gateware",
    BEACON: "Beacon",
    GPS: "Gps",
    WIFI: "Wifi",
    ID: "Id",
    QR: "Qr",
    QR_CODE: "Codice QR",
    PASSWORD: "Password",
    PIN: "Pin",
    CARD: "Tessera",
    FIXED: "Fisso",
    EXTERNAL: "Esterno",
    JAN: "JAN",
    WEB: "Web"
  },
  identity_type: {
    FACE: "Volto",
    PASSWORD: "Password",
    PIN: "Pin",
    FINGER: "Impronta Digitale",
    QR_CODE: "Codice QR",
    CARD: "Tessera",
    EXTERNAL: "Esterno"
  },
  event_types: {
    BREAK_IN: "Inizio Pausa",
    BREAK_OUT: "Fine Pausa",
    LUNCH_IN: "Inizio Pranzo",
    LUNCH_OUT: "Fine Pranzo",
    DUTY_IN: "Inizio Turno",
    DUTY_OUT: "Fine Turno",
    CLOCK_IN: "Entrata",
    CLOCK_OUT: "Uscita",
    UNKNOWN: "Entrata o Uscita",
    undefined: "Sconosciuto"
  },
  currency: {
    amount: "Importo",
    code: "Codice",
    requested_amount: "Importo Richiesto",
    approved_amount: "Importo Approvato",
    codes: {
      TRY: "TRY",
      USD: "USD",
      EUR: "EUR",
      RON: "LEU",
      GBP: "STERLIN",
      AZN: "MANAT",
      RUB: "RUBLE",
      SAR: "RİYAL",
      AED: "UAE-Dirham"
    }
  },
  titles: {
    expense: {
      create: "Aggiungi Spesa",
      detail: "Dettaglio Spesa"
    },
    imprest: {
      create: "Aggiungi Anticipo",
      detail: "Dettaglio Anticipo"
    }
  },
  language: {
    tr: "Turco",
    en: "Inglese",
    de: "Tedesco",
    es: "Spagnolo",
    it: "Italiano",
    pt: "Portoghese",
    TURKISH: "Turco",
    ENGLISH: "Inglese",
    GERMAN: "Tedesco",
    SPANISH: "Spagnolo",
    ITALIAN: "Italiano",
    PORTUGUESE: "Portoghese"
  },
  status: {
    active: "Attivo",
    passive: "Passivo",
    enable: "Abilita",
    disable: "Disabilita"
  },
  gender: {
    male: "Maschio",
    female: "Femmina",
    other: "Altro",
    others: "Altri",
    MALE: "Maschio",
    FEMALE: "Femmina",
    OTHER: "Altro"
  },
  marital_status: {
    married: "Sposato",
    single: "Single",
    divorced: "Divorziato"
  },
  education: {
    student: "Studente",
    primary_school: "Scuola Primaria",
    secondary_school: "Scuola Media",
    high_school: "Scuola Superiore",
    collage: "Collegio",
    university: "Università",
    master: "Master",
    phd: "Dottorato"
  },
  education_languages: {
    turkish: "Turco",
    english: "Inglese",
    german: "Tedesco",
    french: "Francese",
    dutch: "Olandese",
    spanish: "Spagnolo",
    italian: "Italiano",
    arabic: "Arabo",
    russian: "Russo",
    persian: "Persiano",
    chinese: "Cinese",
    japanese: "Giapponese",
    hindi: "Hindi",
    latin: "Latino",
    portuguese: "Portoghese",
    korean: "Coreano"
  },
  military_service: {
    done: "Completato",
    undone: "Non Completato",
    exempt: "Esente",
    suspended: "Sospeso"
  },
  academic_title: {
    lecturer: "Docente",
    research_assistant: "Assistente di Ricerca",
    assistant_professor: "Professore Assistente",
    associate_professor: "Professore Associato",
    professor: "Professore"
  },
  employment_type: {
    full_time: "Tempo Pieno",
    part_time: "Part-time",
    casual: "Occasionale",
    contracted: "Contrattualizzato",
    freelance: "Libero Professionista",
    intern: "Stagista",
    mobile: "Mobile",
    retired: "Pensionato",
    trial: "Periodo di Prova",
    seasonal: "Stagionale",
    disabled: "Disabile"
  },
  collar_type: {
    white: "Bianco",
    blue: "Blu",
    gray: "Grigio"
  },
  quite_job_reasons: {
    resignation: "Dimissioni",
    cancellation_of_labor_contract: "Annullamento del Contratto di Lavoro",
    military_service: "Servizio Militare",
    other: "Altro"
  },
  blood_type: {
    o_rh_negative: "0-",
    o_rh_positive: "0+",
    a_rh_negative: "A-",
    a_rh_positive: "A+",
    b_rh_negative: "B-",
    b_rh_positive: "B+",
    ab_rh_negative: "AB-",
    ab_rh_positive: "AB+"
  },
  time_duration: {
    hour: "Ora",
    minute: "Minuto",
    second: "Secondo"
  },
  date: {
    year: "Anno",
    month: "Mese",
    day: "Giorno",
    time: "Ora",
    week: "Settimana",
    minute: "Minuto"
  },
  validations: {
    messages: {
      phone: "Il campo {_field_} deve essere un numero di telefono valido",
      password_match: "Le password non corrispondono",
      integer: "Il campo {_field_} deve essere un numero intero",
      meaningful_text: "Inserisci una descrizione significativa.",
      amount_range_error: "Il valore di questo campo deve essere compreso tra {min} e {max}."
    }
  },
  nationalities: {
    Afghan: "Afghano",
    Albanian: "Albanese",
    Algerian: "Algerino",
    American: "Americano",
    Andorran: "Andorrano",
    Angolan: "Angolano",
    Antiguans: "Antiguano",
    Argentinean: "Argentino",
    Armenian: "Armeno",
    Australian: "Australiano",
    Austrian: "Austriaco",
    Azerbaijani: "Azerbaigiano",
    Bahamian: "Bahamense",
    Bahraini: "Bahreinita",
    Bangladeshi: "Bengalese",
    Barbadian: "Barbadiano",
    Barbudans: "Barbudano",
    Botswana: "Botswano",
    Belarusian: "Bielorusso",
    Belgian: "Belga",
    Belizean: "Beliziano",
    Beninese: "Beninese",
    Bhutanese: "Bhutanese",
    Bolivian: "Boliviano",
    Bosnian: "Bosniaco",
    Brazilian: "Brasiliano",
    British: "Britannico",
    Bruneian: "Bruneiano",
    Bulgarian: "Bulgaro",
    Burkinabe: "Burkinabé",
    Burmese: "Birmano",
    Burundian: "Burundese",
    Cambodian: "Cambogiano",
    Cameroonian: "Camerunese",
    Canadian: "Canadese",
    "Cape Verdean": "Capoverdiano",
    "Central African": "Centrafricano",
    Chadian: "Ciadiano",
    Chilean: "Cileno",
    Chinese: "Cinese",
    Colombian: "Colombiano",
    Comoran: "Comoriano",
    Congolese: "Congolese",
    "Costa Rican": "Costaricano",
    Croatian: "Croato",
    Cuban: "Cubano",
    Cypriot: "Cipriota",
    Czech: "Ceco",
    Danish: "Danese",
    Djibouti: "Gibutiano",
    Dominican: "Dominicano",
    Dutch: "Olandese",
    "East Timorese": "Est-timorese",
    Ecuadorean: "Ecuadoriano",
    Egyptian: "Egiziano",
    Emirian: "Emiratino",
    "Equatorial Guinean": "Guineano Equatoriale",
    Eritrean: "Eritreo",
    Estonian: "Estone",
    Ethiopian: "Etiope",
    Fijian: "Figiano",
    Filipino: "Filippino",
    Finnish: "Finlandese",
    French: "Francese",
    Gabonese: "Gabonese",
    Gambian: "Gambiano",
    Georgian: "Georgiano",
    German: "Tedesco",
    Ghanaian: "Ghanese",
    Greek: "Greco",
    Grenadian: "Grenadino",
    Guatemalan: "Guatemalteco",
    "Guinea-Bissauan": "Guinea-Bissauano",
    Guinean: "Guineano",
    Guyanese: "Guyanese",
    Haitian: "Haitiano",
    Herzegovinian: "Erzegovino",
    Honduran: "Honduregno",
    Hungarian: "Ungherese",
    "I-Kiribati": "I-Kiribati",
    Icelander: "Islandese",
    Indian: "Indiano",
    Indonesian: "Indonesiano",
    Iranian: "Iraniano",
    Iraqi: "Iracheno",
    Irish: "Irlandese",
    Israeli: "Israeliano",
    Italian: "Italiano",
    Ivorian: "Ivoriano",
    Jamaican: "Giamaicano",
    Japanese: "Giapponese",
    Jordanian: "Giordano",
    Kazakhstani: "Kazako",
    Kenyan: "Keniota",
    "Kittian and Nevisian": "Kittiano e Nevisiano",
    Kuwaiti: "Kuwaitiano",
    Kyrgyz: "Kirghiso",
    Laotian: "Laotiano",
    Latvian: "Lettone",
    Lebanese: "Libanese",
    Liberian: "Liberiano",
    Libyan: "Libico",
    Liechtensteiner: "Liechtensteinese",
    Lithuanian: "Lituano",
    Luxembourger: "Lussemburghese",
    Macedonian: "Macedone",
    Malagasy: "Malgascio",
    Malawian: "Malawiano",
    Malaysian: "Malese",
    Maldivan: "Maldiviano",
    Malian: "Maliano",
    Maltese: "Maltese",
    Marshallese: "Marshallese",
    Mauritanian: "Mauritano",
    Mauritian: "Mauriziano",
    Mexican: "Messicano",
    Micronesian: "Micronesiano",
    Moldovan: "Moldavo",
    Monacan: "Monegasco",
    Mongolian: "Mongolo",
    Moroccan: "Marocchino",
    Mosotho: "Mosotho",
    Motswana: "Motswana",
    Mozambican: "Mozambicano",
    Namibian: "Namibiano",
    Nauruan: "Nauruano",
    Nepalese: "Nepalese",
    "New Zealander": "Neozelandese",
    Nicaraguan: "Nicaraguense",
    Nigerian: "Nigeriano",
    Nigerien: "Nigerino",
    "North Korean": "Nord Coreano",
    "Northern Irish": "Nord Irlandese",
    Norwegian: "Norvegese",
    Omani: "Omanita",
    Pakistani: "Pakistano",
    Palauan: "Palauano",
    Panamanian: "Panamense",
    "Papua New Guinean": "Papua Nuova Guinea",
    Paraguayan: "Paraguaiano",
    Peruvian: "Peruviano",
    Polish: "Polacco",
    Portuguese: "Portoghese",
    Qatari: "Qatariota",
    Romanian: "Rumeno",
    Russian: "Russo",
    Rwandan: "Ruandese",
    "Saint Lucian": "Saint Luciano",
    Salvadoran: "Salvadoregno",
    Samoan: "Samoano",
    "San Marinese": "Sammarinese",
    "Sao Tomean": "Sao Tomese",
    Saudi: "Saudita",
    Scottish: "Scozzese",
    Senegalese: "Senegalese",
    Serbian: "Serbo",
    Seychellois: "Seychellese",
    "Sierra Leonean": "Sierra Leonese",
    Singaporean: "Singaporiano",
    Slovakian: "Slovacco",
    Slovenian: "Sloveno",
    "Solomon Islander": "Salomonese",
    Somali: "Somalo",
    "South African": "Sudafricano",
    "South Korean": "Sud Coreano",
    Spanish: "Spagnolo",
    "Sri Lankan": "Sri Lankese",
    Sudanese: "Sudanese",
    Surinamer: "Surinamese",
    Swazi: "Swazi",
    Swedish: "Svedese",
    Swiss: "Svizzero",
    Syrian: "Siriano",
    Taiwanese: "Taiwanese",
    Tajik: "Tagiko",
    Tanzanian: "Tanzaniano",
    Thai: "Thailandese",
    Togolese: "Togolese",
    Tongan: "Tongano",
    "Trinidadian or Tobagonian": "Trinidadiano o Tobagoniano",
    Tunisian: "Tunisino",
    Turkish: "Turco",
    Tuvaluan: "Tuvaluano",
    Ugandan: "Ugandese",
    Ukrainian: "Ucraino",
    Uruguayan: "Uruguaiano",
    Uzbekistani: "Uzbeko",
    Venezuelan: "Venezuelano",
    Vietnamese: "Vietnamita",
    Welsh: "Gallese",
    Yemenite: "Yemenita",
    Zambian: "Zambiano",
    Zimbabwean: "Zimbabwese"
  },
  disability_level: {
    first_level: "Primo Livello",
    second_level: "Secondo Livello",
    third_level: "Terzo Livello"
  },
  social_security_type: {
    SS_4A: "4A",
    SS_4B: "4B",
    SS_4C: "4C"
  },
  clock_ip_error: "L'indirizzo IP non è tra gli indirizzi IP consentiti",
  days: {
    monday: "Lunedì",
    tuesday: "Martedì",
    wednesday: "Mercoledì",
    thursday: "Giovedì",
    friday: "Venerdì",
    saturday: "Sabato",
    sunday: "Domenica"
  },
  api_error: {
    756: "C'è una richiesta di ferie tra le date richieste",
    766: "La password deve essere lunga almeno 8 e al massimo 16 caratteri",
    767: "La password deve contenere lettere minuscole, maiuscole, numeri e caratteri speciali: .-/@#$%^&_+=()",
    768: "La password non può includere il tuo nome, cognome o numero dipendente",
    769: "Questa password è già stata utilizzata, inserisci una password diversa dalle tue ultime {0} password",
    800: "Tentativo di accesso fallito",
    801: "Errore di verifica SMS",
    802: "Troppi tentativi falliti di verifica OTP",
    803: "Identità non trovata",
    804: "Accesso mobile disabilitato",
    805: "Credenziali non valide",
    806: "Errore di verifica password",
    807: "Login SSO fallito",
    808: "Errore di verifica Captcha",
    809: "Verifica dispositivo fallita",
    810: "Errore di verifica canale",
    811: "Errore di autenticazione",
    812: "Errore di verifica JWT",
    813: "Verifica codice TOTP fallita",
    814: "Il tipo SSO non può essere nullo"
  },
  http: {
    200: "Inviato con successo",
    201: "Successo",
    202: "Salvato con successo",
    401: "Non autorizzato",
    404: "Non trovato",
    409: "Conflitto dati",
    415: "Tipo di media non supportato",
    204: "Successo",
    304: "Non modificato",
    500: "Errore interno del server",
    503: "Servizio non disponibile"
  },
  expense_items: "Voci di Spesa",
  expense_item_name: "Nome Voce di Spesa",
  update_expense_item: "Aggiorna Voce di Spesa",
  add_expense_item: "Aggiungi Voce di Spesa",
  file_format_error: "Errore Formato File",
  file_size_error: "Errore Dimensione File",
  not_selected_expense_item_error_message: "Non hai aggiunto una voce di spesa",
  expense_description: "Descrizione Spesa",
  abolisher_employee: "Dipendente Abolente",
  expense_manager: "Responsabile Spese",
  event_date: "Data Evento",
  cancelled_date: "Data Cancellazione",
  approval_history: "Cronologia Approvazioni",
  request_processes: {
    super_admin: "Approvato da Super Admin",
    approved: "Richiesta approvata",
    pending: "In attesa di approvazione",
    stopped: "Processo di approvazione interrotto perché la richiesta è stata rifiutata",
    waiting: "Non è il momento dell'approvazione",
    denied: "Richiesta rifiutata"
  },
  sso_forgot_password_warning: {
    title: "Attenzione",
    message: "Per favore accedi a Idenfit usando la tua email Accenture."
  },
  time_abbr: {
    hour: "ore",
    minute: "min",
    second: "sec"
  },
  vedubox_user_not_found: "Utente Vedubox non trovato",
  gdpr: {
    acceptance: {
      title: "Accettazione Informativa Privacy",
      checkbox: "Accetto l'informativa sulla privacy.",
      save: "Salva e Continua",
      formError: "Devi accettare l'informativa sulla privacy per continuare."
    }
  },
  web_terminal_loading: "Il terminale web sta caricando",
  web_terminal_not_found: "Terminale web non trovato",
  multiple_assigned_shift_warning: "Hai più di un turno assegnato. Seleziona uno dei turni qui sotto.",
  paper_approval: "Approvazione Documento",
  paperApprovalProcessWarningMessage: "Devi scaricare o visualizzare il file",
  minLength: "Almeno 8 caratteri",
  hasLowerCaseAndUpperCase: "Contiene numeri, lettere maiuscole e minuscole",
  hasSpecialCharacter: "Contiene caratteri speciali",
  passwordExpireNotificationMessage:
    "Manca 0 giorni alla scadenza della password | Manca 1 giorno alla scadenza della password | Mancano {count} giorni alla scadenza della password",
  pendingRequests: "Richieste in Sospeso",
  allPendingRequests: "Tutte le Richieste in Sospeso",
  maxImprestAmountMessage: "Limite massimo richiedibile: {0}",
  or: "oppure",
  continueWithMicrosoft: "Continua con Microsoft",
  authCode: "Codice di Autenticazione",
  verify: "Verifica",
  totpVerifyMessage: "Devi aprire l'app di autenticazione a due fattori per vedere il codice di autenticazione",
  totpCodeInvalid: "Hai inserito un codice di autenticazione non valido",
  totpRegisterMessage1:
    "Scansiona il codice QR qui sotto con l'app di autenticazione a due fattori sul tuo telefono. Se non riesci a scansionare il codice QR, usa invece questo codice <strong>{0}</strong>.",
  totpRegisterMessage2: "Inserisci il codice a sei cifre dall'app qui sotto",
  taskManagement: {
    task: "Attività",
    tasks: "Attività",
    parentTask: "Attività Principale",
    categories: "Categorie",
    completed: "Completate",
    notCompleted: "Non Completate",
    addTask: "Aggiungi Attività",
    taskDetail: "Dettaglio Attività",
    title: "Titolo",
    sender: "Creato Da",
    senders: "Creatori",
    taskCategory: "Categoria Attività",
    taskCategories: "Categorie Attività",
    followers: "Follower",
    addTaskCategory: "Aggiungi Categoria",
    taskCategoryDetail: "Dettaglio Categoria",
    labels: "Etichette",
    labelPlaceholder: "Inserisci il nome dell'etichetta e premi Invio o clicca il pulsante per aggiungerla",
    taskCompleted: "Attività Completata",
    taskNotCompleted: "Attività Non Completata",
    attachments: "Allegati",
    uploadFile: "Clicca per caricare il file",
    details: "Dettagli",
    conversation: "Commento",
    conversations: "Commenti",
    noConversation: "Nessun commento inserito",
    notify: "Abilita Notifiche",
    responsibles: "Responsabili",
    writeComment: "Scrivi un commento...",
    subtasks: "Sottoattività",
    importance: "Priorità",
    completedTasks: "Attività Completate",
    notCompletedTasks: "Attività Non Completate",
    subtasksMustBeCompleted: "Le sottoattività devono essere completate prima di completare l'attività principale",
    subtaskModificationNotAllowed: "Non può essere modificata perché l'attività principale è completata",
    updatedDateTime: "Data Ultima Modifica",
    filterByTitle: "Filtra per Titolo",
    filterTasks: "Filtra Attività",
    onlyMyTasks: "Attività Create da Me",
    onlyMyFollowedTasks: "Attività che Seguo",
    onlyMyResponsibleTasks: "Attività di cui Sono Responsabile",
    onlyMyTeamTasks: "Attività del Mio Team",
    selectTaskView: "Seleziona Vista Attività",
    reportFileName: "report_attivita"
  },
  dynamicFields: {
    title: "Campi Dinamici"
  },
  file: {
    preview: "Anteprima file",
    download: "Scarica",
    download_error: "Download fallito",
    unsupported_format: "Questo formato di file non è supportato per l'anteprima"
  }
};
